import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

type VersionUpdateDialogProps = {
	open: boolean;
	currentVersion: string | null;
	latestVersion: string | null;
	onClose: () => void;
	onUpdate: () => void;
};

export const VersionUpdateDialog = ({
	open,
	currentVersion,
	latestVersion,
	onClose,
	onUpdate,
}: VersionUpdateDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="version-update-dialog-title"
			aria-describedby="version-update-dialog-description">
			<DialogTitle id="version-update-dialog-title">{t("new-version-available")}</DialogTitle>
			<DialogContent>
				<DialogContentText id="version-update-dialog-description">
					{t("new-version-message", {
						currentVersion: currentVersion || "unknown",
						latestVersion: latestVersion || "unknown",
					})}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="secondary">
					{t("later")}
				</Button>
				<Button onClick={onUpdate} color="primary" variant="contained" autoFocus>
					{t("reload-now")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
